import { useState } from 'react';
import type { Faq } from '@/types/site';

interface FaqAccordionProps {
  items: Faq[];
  defaultOpen?: number;
}

export default function FaqAccordion({ items, defaultOpen = 0 }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpen);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.question}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100 cursor-pointer"
                aria-expanded={isOpen}
              >
                <span className="flex items-start gap-3">
                  <span className="mt-0.5 font-heading text-sm font-semibold text-primary-500">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="font-heading text-sm font-medium text-foreground-950 md:text-base">
                    {item.question}
                  </span>
                </span>
                <i
                  className={`shrink-0 text-lg text-foreground-400 transition-transform duration-300 ${
                    isOpen ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
            </h3>
            {isOpen && (
              <div className="px-5 pb-5 pl-[3.25rem] text-sm leading-relaxed text-foreground-600">
                {item.answer}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}